import { useAuth } from "@/hooks/useAuth";
import { viewTier, type ViewTier } from "@/lib/tier";

/** The signed-in user's experience tier (admin by role, else profiles.tier). */
export function useTier(): ViewTier {
  const { session } = useAuth();
  return viewTier(session?.role, session?.tier);
}
